/* konnae. Anmeldeformulare → Klaviyo (Client Subscriptions API).
   Double-Opt-in steuert die Liste in Klaviyo, nicht dieses Skript.
   Die Herkunft wird nur aus dem aktuellen Link gelesen (utm_*). Es wird nichts im Browser gespeichert,
   deshalb funktioniert das Formular auch, wenn jemand alle Cookies ablehnt. */
(function () {
  'use strict';
  if (window.knSignupReady) return;
  window.knSignupReady = true;

  var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/?company_id=';
  // Klaviyo-API-Version. Klaviyo unterstützt jede Version zwei Jahre lang: bis Mitte 2028 auf eine neuere heben.
  var REVISION = '2026-07-15';

  // utm-Parameter → Profil-Eigenschaft in Klaviyo
  var UTM_FIELDS = {
    utm_source: 'quelle',
    utm_medium: 'medium',
    utm_campaign: 'utm_kampagne',
    utm_content: 'motiv'
  };

  function param(name) {
    try {
      return (new URLSearchParams(window.location.search).get(name) || '').trim().slice(0, 100);
    } catch (e) {
      return '';
    }
  }

  function setBusy(form, busy) {
    form.setAttribute('data-kn-busy', busy ? '1' : '');
    var button = form.querySelector('button[type="submit"]');
    if (button) button.disabled = busy;
  }

  function showSuccess(form) {
    var root = form.closest('[data-kn-signup]');
    var success = root && root.querySelector('[data-kn-success]');
    form.hidden = true;
    if (success) {
      success.hidden = false;
      success.focus();
    }
  }

  function showError(form) {
    var error = form.querySelector('[data-kn-error]');
    if (error) error.hidden = false;
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[data-kn-form]')) return;
    event.preventDefault();
    if (form.getAttribute('data-kn-busy') === '1') return;

    var error = form.querySelector('[data-kn-error]');
    if (error) error.hidden = true;

    // Honeypot: Bots füllen das unsichtbare Feld, Menschen nicht. Bots sehen trotzdem „Erfolg“.
    var trap = form.querySelector('input[name="website"]');
    if (trap && trap.value) {
      showSuccess(form);
      return;
    }

    var emailInput = form.querySelector('input[name="email"]');
    var email = emailInput ? emailInput.value.trim() : '';
    if (!email) {
      if (emailInput) emailInput.focus();
      return;
    }

    var key = form.getAttribute('data-kn-key') || '';
    var list = form.getAttribute('data-kn-list') || '';
    if (!/^[A-Za-z0-9]+$/.test(key) || !/^[A-Za-z0-9]+$/.test(list)) {
      if (window.console) console.warn('[konnae.] Klaviyo-Schlüssel oder Listen-ID fehlt in snippets/kn-signup-form.liquid');
      showError(form);
      return;
    }

    var type = form.getAttribute('data-kn-type') || 'leadmagnet';
    var props = { language: form.getAttribute('data-kn-lang') || 'en' };
    props[type] = 'ja';
    props[type + '_am'] = new Date().toISOString().slice(0, 10);
    var consentVersion = form.getAttribute('data-kn-consent');
    if (consentVersion) props[type + '_einwilligung'] = consentVersion;

    // Nur setzen, was im Link steht. Fehlt ein Wert, bleibt der alte im Profil erhalten.
    Object.keys(UTM_FIELDS).forEach(function (utm) {
      var value = param(utm);
      if (value) props[UTM_FIELDS[utm]] = value;
    });

    // Kästchen für die Briefe: nur „ja“ senden, nie „nein“, damit eine frühere Zustimmung nicht überschrieben wird.
    var letters = form.querySelector('input[name="briefe"]');
    if (letters && letters.checked) props.briefe = 'ja';

    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: form.getAttribute('data-kn-source') || window.location.pathname,
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email, properties: props }
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: list } }
        }
      }
    };

    setBusy(form, true);
    fetch(ENDPOINT + encodeURIComponent(key), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        'revision': REVISION
      },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Klaviyo antwortet mit ' + response.status);
        showSuccess(form);
      })
      .catch(function (err) {
        if (window.console) console.warn('[konnae.] Anmeldung fehlgeschlagen:', err);
        showError(form);
      })
      .then(function () {
        setBusy(form, false);
      });
  });
})();
